export interface InstitutionalLink {
  label: string;
  href: string;
  external?: boolean;
}

/*
------------------------------------------------------------
Links fixos do cabeçalho
------------------------------------------------------------
Apontam para o portal atual do MPF, fora deste site, e por isso não vêm da
navegação. Ficam aqui para a barra superior (desktop) e o menu mobile lerem a
mesma lista.
------------------------------------------------------------
*/
export const INSTITUTIONAL_LINKS: InstitutionalLink[] = [
  {
    label: 'Acesso à Informação',
    href: '/servicos/acesso-a-informacao/solicitacoes-de-informacao-lai',
  },
  {
    label: 'Transparência',
    href: 'https://transparencia.mpf.mp.br',
    external: true,
  },
];

/*
Item da home. O `@navigation` só devolve as seções do primeiro nível — a raiz
não vem na lista —, então a entrada é montada aqui. O título continua no HTML
(leitor de tela e SEO); na tela quem aparece é o ícone de casa.
*/
export const HOME_MENU_ITEM = {
  title: 'Página inicial',
  url: '/',
};

export const ACCESSIBILITY_URL = '/acessibilidade';
export const SITEMAP_URL = '/sitemap';
